import { withNamespace } from '../helper';

const namespace = '@TAG';

export const GET_TAG = withNamespace('GET_TAG', namespace);
export const GET_TAG_SUCCESS = withNamespace('GET_TAG_SUCCESS', namespace);

export const GET_TAGS = withNamespace('GET_TAGS', namespace);
export const GET_TAGS_SUCCESS = withNamespace('GET_TAGS_SUCCESS', namespace);

export const CREATE_TAG = withNamespace('CREATE_TAG', namespace);
export const CREATE_TAG_SUCCESS = withNamespace('CREATE_TAG_SUCCESS', namespace);

export const UPDATE_TAG = withNamespace('UPDATE_TAG', namespace);
export const UPDATE_TAG_SUCCESS = withNamespace('UPDATE_TAG_SUCCESS', namespace);

export const DELETE_TAG = withNamespace('DELETE_TAG', namespace);
export const DELETE_TAG_SUCCESS = withNamespace('DELETE_TAG_SUCCESS', namespace);
